import { Link } from "react-router-dom";
import logo from "../images/logo.png";

const HeaderLogo = () => {
  return (
    <Link to={"/"} className="website_header_logo">
      <img src={logo} alt="header_logo" />
    </Link>
  );
};

export default HeaderLogo;
